import React, {ReactText, FC} from 'react';
import {useDispatch} from 'react-redux';

import {selectMetadata} from 'entities/metadata';
import {selectEntityData} from 'modules/data';
import {createActionHandlerForDelete} from 'modules/data/data-actions';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {ERequestType} from 'shared/types/requests';
import {useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ActionConfirmModal} from '../action-confirm-modal/action-confirm-modal';
import {
    DEFAULT_DELETE_ELEMENT_CONFIRM_TEXT,
} from '../button-action-delete-tab/constants/button-delete-tab-constants';
import {ITableActionProps} from '../table-action-types';

interface IButtonActionForDeleteRowsOwnProps extends ITableActionProps {
    isDisabled?: boolean;
}

const ButtonActionForDeleteRowsComponent: FC<IButtonActionForDeleteRowsOwnProps> = ({
    wrapper,
    meta,
    entityName,
    isDisabled = false,
    ...props
}: IButtonActionForDeleteRowsOwnProps) => {
    const referenceUrl = meta?.referenceUrl || entityName;
    const requestType = meta?.requestType || ERequestType.POST;
    const {urlConfig} = useAppSelector(selectMetadata(entityName, EEntityType.TABLE)) || {};

    const {selectedRowKeys = []} = useAppSelector(selectEntityData(entityName, EEntityType.TABLE)) as ITableEntityData
        ?? {};

    const dispatch = useDispatch();
    const actionsForRows = (ids: ReactText[]) => dispatch(
        createActionHandlerForDelete({
            entityName,
            referenceUrl,
            requestType,
            itemList: meta?.itemListKey ? {[meta.itemListKey]: ids} : {ids},
            urlConfig: meta?.shouldIgnoreUrlConfig ? undefined : urlConfig,
        }),
    );
    const handleDelete = () => {
        actionsForRows(selectedRowKeys);
    };
    const Component = wrapper || ActionButton;

    return (
        <ActionConfirmModal
            cancelText="Отмена"
            approveText="Удалить"
            modalTitle="Удаление"
            confirmModalContent={DEFAULT_DELETE_ELEMENT_CONFIRM_TEXT}
            confirmAction={handleDelete}
        >
            {handleClick => (
                <Component
                    {...props}
                    onClick={handleClick}
                    actionIcon={meta.actionIcon}
                    disabled={!selectedRowKeys.length || isDisabled}
                    className="table-action critic-action"
                >
                    {meta.actionTitle}
                </Component>
            )}

        </ActionConfirmModal>
    );
};

export const ButtonActionForDeleteRows = ButtonActionForDeleteRowsComponent;
